import { OnboardingTitle } from '../../OnboardingLayout';

/**
 * Terminal screen for an account without alpha access. Replaces the
 * account-connection step, so a waitlisted caregiver finishes the parts of the
 * wizard that describe their household and is never asked for bank
 * credentials or a subscription the account can't act on.
 *
 * Carries no back arrow and no CTA: there is nothing past it, and the
 * `/onboarding` route decision lands a returning waitlisted viewer straight
 * back here.
 */
const WaitlistedStep = () => {
  return (
    <OnboardingTitle
      title="Thanks for registering"
      subtitle="You have been added to our waitlist and we will be in touch soon."
    />
  );
};

WaitlistedStep.displayName = 'WaitlistedStep';

export default WaitlistedStep;
